import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';

const MenuBar = ({ selected, onSelect }) => {
  const token = getToken();
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/pos_category-report`;
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        const data = response.data.report || [];
        setMenus(data);
        if (data.length > 0) {
          onSelect(data[0]); // Set the first menu as default
        }
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };

    fetchMenu();
  }, []);

  return (
    <div className="d-flex flex-wrap gap-3 mb-4">
      {menus.map(menu => (
        <button
          key={menu.ID}
          onClick={() => onSelect(menu)}
          className={`btn btn-lg px-4 py-2 fw-semibold rounded-pill shadow-sm transition 
            ${selected?.ID === menu.ID ? 'btn-dark text-white' : 'btn-outline-dark bg-white'}`}
        >
          {menu.Name}
        </button>
      ))}
    </div>
  );
};

export default MenuBar;
